module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABVN4hVN4hVN4hVN4hnTZXh6O0pLzMpLzMpLzMpLzPMVlipAAAAC3RSTlMAUN//AP///99QAAky7VEAAABiSURBVHgBY2BUNhJxIQAYhI2NDQkqUjY2Nk2DgnIoQOVXzGIwBgL8isoriVFUQYyi8iGuaFQRuiQ6n1hFo4pGFY1mqVFFFRRVQJhVmQsBMNgUjSoaVYRorhlRp+HnSEQTEgD9fZv1MibH9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3c1.png
// module id = 799
// module chunks = 0